/**
 * User: herbert
 * Date: 10.05.16
 * Time: 10:37
 */

// the whole app is presentation only so we disable jsx-ally
/* eslint jsx-a11y/onclick-has-role: 0 */
/* eslint jsx-a11y/img-has-alt: 0 */

import React from 'react';

export default function () {
	return (
		<div className="slx-stele-summary__rgbw" >
			<div className="slx-stele-summary__optiongroup slx-stele-summary__optiongroup--defaultHeight" />
		</div>
	);
}

